import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ADS_ID = "AW-16832352541";
const PROD_HOSTS = new Set(["vaslola.com", "www.vaslola.com"]);

function ensureGtagStub() {
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag !== "function") {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

function loadGtagScript() {
  if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${ADS_ID}"]`)) {
    return;
  }
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
  document.head.appendChild(script);
}

function scheduleIdle(fn) {
  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(() => fn(), { timeout: 4000 });
    return;
  }
  window.setTimeout(fn, 2000);
}

function deferUntilIdle(fn) {
  if (document.readyState === "complete") {
    scheduleIdle(fn);
    return;
  }
  window.addEventListener(
    "load",
    () => {
      scheduleIdle(fn);
    },
    { once: true },
  );
}

export default function GoogleAdsTracker() {
  const location = useLocation();

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (!PROD_HOSTS.has(window.location.hostname)) return;

    ensureGtagStub();
    deferUntilIdle(() => {
      ensureGtagStub();
      loadGtagScript();
      window.gtag("js", new Date());
    });
  }, []);

  useEffect(() => {
    if (process.env.NODE_ENV !== "production") return;
    if (!PROD_HOSTS.has(window.location.hostname)) return;

    const pagePath = location.pathname + location.search;
    if (window.__vaslolaAdsPage === pagePath) return;
    window.__vaslolaAdsPage = pagePath;

    ensureGtagStub();

    const eventName = location.state?.event?.name;
    const payload = {
      page_path: pagePath,
      page_title: eventName || document.title,
      page_location: window.location.href,
    };

    // Safe if the real gtag script has not loaded yet: stub queues into dataLayer.
    if (typeof window.gtag === "function") {
      window.gtag("config", ADS_ID, payload);
    }
  }, [location]);

  return null;
}
